import { Truck } from "lucide-react";

const items = [
  "SAME-DAY DISPATCH",
  "$1M LIABILITY INSURED",
  "BBB A+ ACCREDITED",
  "70% ZERO-LANDFILL RATE",
  "1,240+ 5-STAR JOBS",
  "24/7 CREW ON CALL",
];

export default function TickerBar() {
  return (
    <div className="bg-[#0C2E2B] text-white overflow-hidden border-y-2 border-[#FFDF00]">
      <div className="marquee py-4">
        {[...items, ...items].map((t, i) => (
          <div key={`${t}-${i}`} className="flex items-center gap-3 shrink-0">
            <Truck className="w-4 h-4 text-[#FFDF00]" />
            <span className="font-tactical text-sm tracking-[0.25em] font-bold whitespace-nowrap">{t}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
